"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DIVIDER_APPEARANCES = void 0;
var DIVIDER_APPEARANCES = Object.freeze({
  regular: 'regular',
  emphasized: 'emphasized'
});
exports.DIVIDER_APPEARANCES = DIVIDER_APPEARANCES;